<div
  #card="tuiActiveZone"
  (tuiActiveZoneChange)="onZoneChange($event)"
  *tuiLet="parentPreOrder$ | async as parentPreOrder"
>
  <div class="flex gap-x-2 mb-2">
    <app-autocomplete
      class="w-2/12"
      tuiDropdownContext
      #clientJsonDropdown="tuiDropdown"
      [tuiDropdown]="clientJsonContext"
      [appCompareWithField]="parentPreOrder?.clientJson?.id"
      [formControl]="orderForm.controls.clientJson.controls.id"
      [items]="catalogs.clients$ | async"
      [itemText]="'name'"
      [itemValue]="'id'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
      label="Мой клиент"
      [labelOutside]="false"
      (valueChanged)="onClientChange()"
    ></app-autocomplete>
    <ng-template #clientJsonContext>
      <tui-data-list role="menu" tuiDataListDropdownManager>
        <button
          (click)="
            openClientDialog$.next('create'); clientJsonDropdown.toggle(false)
          "
          tuiOption
        >
          Добавить клиента в каталог
        </button>
        <button
          [disabled]="!orderForm.controls.clientJson.controls.id.value"
          (click)="
            openClientDialog$.next('edit'); clientJsonDropdown.toggle(false)
          "
          tuiOption
        >
          Редактировать клиента
        </button>
      </tui-data-list>
    </ng-template>
    <app-autocomplete
      tuiDropdownContext
      #clientAddressWithCoordinatesJsonDropdown="tuiDropdown"
      [tuiDropdown]="clientAddressWithCoordinatesJsonContext"
      class="w-2/12"
      label="Адрес"
      [appCompareWithField]="
        parentPreOrder?.clientAddressWithCoordinatesJson?.address
      "
      [labelOutside]="false"
      (valueChanged)="onAddressChange()"
      [formControl]="
        orderForm.controls.clientAddressWithCoordinatesJson.controls.address
      "
      [items]="availableAddresses$ | async"
      [itemText]="'address'"
      [itemValue]="'address'"
      tuiTextfieldSize="m"
      >Адрес</app-autocomplete
    >
    <ng-template #clientAddressWithCoordinatesJsonContext>
      <tui-data-list>
        <button
          (click)="
            addCustomLocation$.next();
            clientAddressWithCoordinatesJsonDropdown.toggle(false)
          "
          tuiOption
        >
          Добавить произвольный адрес
        </button>
      </tui-data-list>
    </ng-template>
    <app-autocomplete
      tuiDropdownContext
      #farmJsonDropdown="tuiDropdown"
      [tuiDropdown]="farmJsonContext"
      class="w-2/12"
      [appCompareWithField]="parentPreOrder?.farmJson?.id"
      [formControl]="orderForm.controls.farmJson.controls.id"
      [items]="catalogs.farms$ | async"
      [itemText]="'name'"
      [itemValue]="'id'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
      label="Питомник"
      [hintContent]="
        farmJson.controls.taxNonPayer.getRawValue() ? 'Неплательщик НДС' : ''
      "
      [labelOutside]="false"
      (valueChanged)="onFarmChange()"
    ></app-autocomplete>
    <ng-template #farmJsonContext>
      <tui-data-list role="menu" tuiDataListDropdownManager>
        <button
          [disabled]="!orderForm.controls.farmJson.controls.id.value"
          (click)="openFarmDialog$.next('edit'); farmJsonDropdown.toggle(false)"
          tuiOption
        >
          Редактировать питомник
        </button>
      </tui-data-list>
    </ng-template>
    <app-autocomplete
      class="w-2/12"
      [appCompareWithField]="parentPreOrder?.farmAddress?.address"
      [formControl]="orderForm.controls.farmAddress.controls.address"
      [items]="availableFarmAddresses$ | async"
      [itemText]="'address'"
      [itemValue]="'address'"
      [displayValue]="'address'"
      [itemSearch]="'address'"
      label="Адрес"
      [labelOutside]="false"
      (valueChanged)="onFarmAddressChange($event)"
    ></app-autocomplete>
    <app-autocomplete
      class="w-2/12"
      [appCompareWithField]="parentPreOrder?.flowerType"
      [formControl]="orderForm.controls.flowerType"
      [items]="availableFlowerTypes$ | async"
      [itemSearch]="'search'"
      [itemText]="'name'"
      [itemValue]="'id'"
      [displayValue]="'name'"
      label="Группа товаров"
      [labelOutside]="false"
    ></app-autocomplete>

    <div class="w-1/12 flex items-center">
      <tui-toggle
        [appCompareWithField]="parentPreOrder?.imported"
        [formControl]="orderForm.controls.imported"
        size="m"
        class="mx-2"
      ></tui-toggle>
      <span class="text-sm">Импорт</span>
    </div>
    <div class="w-1/12 flex items-center">
      <app-checkbox
        [appCompareWithField]="parentPreOrder?.cold"
        [formControl]="orderForm.controls.cold"
      ></app-checkbox>
      <span class="px-2">Холод</span>
    </div>
  </div>
  <div class="flex gap-x-2 mb-2" *tuiLet="isImport$ | async as isImport">
    <div
      class="w-2/12"
      tuiDropdownContext
      #buyerCodeDropdown="tuiDropdown"
      [tuiDropdown]="buyerCodeContext"
    >
      <app-autocomplete
        label="Код покупателя"
        [appCompareWithField]="parentPreOrder?.buyerCode"
        [strict]="false"
        [labelOutside]="false"
        [formControl]="orderForm.controls.buyerCode"
        [items]="buyersOfSelectedFarm$ | async"
        [itemSearch]="'search'"
        [itemValue]="'code'"
        [displayValue]="'code'"
        [itemText]="'code'"
      ></app-autocomplete>
      <ng-template #buyerCodeContext>
        <tui-data-list role="menu" tuiDataListDropdownManager>
          <button
            (click)="
              openCreateBuyerDialog$.next(); buyerCodeDropdown.toggle(false)
            "
            tuiOption
          >
            Добавить покупателя в каталог
          </button>
        </tui-data-list>
      </ng-template>
    </div>
    @if (isImport) {
      <div class="flex gap-x-2 w-3/12">
        <app-autocomplete
          class="w-3/12"
          [items]="countries()"
          [itemText]="'name'"
          [itemValue]="'letterCode'"
          [itemSearch]="'search'"
          [appCompareWithField]="parentPreOrder?.countryLetter"
          [formControl]="orderForm.controls.countryLetter"
        ></app-autocomplete>
        <tui-input
          class="w-4/12"
          [appCompareWithField]="parentPreOrder?.airWaybillNumber"
          [formControl]="orderForm.controls.airWaybillNumber"
          tuiTextfieldSize="m"
          >AWB</tui-input
        >
        <div class="w-1/12 flex mt-2.5">
          <app-checkbox
            [appCompareWithField]="parentPreOrder?.precooling"
            [formControl]="orderForm.controls.precooling"
            [tuiHint]="precooling"
          ></app-checkbox>
          <ng-template #precooling> Pre-cooling </ng-template>
        </div>

        <tui-input-number
          class="w-4/12"
          tuiTextfieldSize="m"
          [appCompareWithField]="parentPreOrder?.weight"
          [formControl]="orderForm.controls.weight"
          >Вес</tui-input-number
        >
      </div>
    }
    <div
      *tuiLet="(cargoLoadingService.readonly$ | async)! as readonly"
      [class]="isImport ? 'w-7/12' : 'w-10/12'"
    >
      <app-cargo-place-details
        *ngFor="
          let details of orderForm.controls.cargoPlacesJson.controls;
          let index = index;
          let last = last
        "
        (create)="addCargoPlaceDetails()"
        (remove)="removeCargoPlaceDetails(index)"
        [isImport]="(isImport$ | async)!"
        [last]="last"
        [canCreate]="!readonly"
        [canRemove]="!readonly"
        [cargoPlaceDetailsForm]="details"
        [parentDetails]="parentPreOrder?.cargoPlacesJson?.[index] ?? null"
      ></app-cargo-place-details>
      @if (!orderForm.controls.cargoPlacesJson.controls.length) {
        <button
          [disabled]="readonly"
          (click)="addCargoPlaceDetails()"
          class="mt-1.5"
          size="s"
          icon="tuiIconPlus"
          tuiButton
        >
          Добавить грузовое место
        </button>
      }
    </div>
  </div>
  <div class="flex gap-x-2">
    <app-autocomplete
      [appCompareWithField]="parentPreOrder?.brokerJson?.id"
      label="Посредник"
      [labelOutside]="false"
      class="w-2/12"
      [formControl]="orderForm.controls.brokerJson.controls.id"
      [items]="sellers$ | async"
      [itemValue]="'id'"
      [itemText]="'name'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
      (valueChanged)="fillBrokerJson($event)"
    >
    </app-autocomplete>
    <div class="w-[140px] flex items-center">
      <tui-toggle
        [appCompareWithField]="parentPreOrder?.prepayment"
        [formControl]="orderForm.controls.prepayment"
        size="m"
        class="mx-2"
      ></tui-toggle>
      <span class="text-sm">Предоплата</span>
    </div>
    <div class="w-[140px]">
      <app-input-date
        [appCompareWithField]="parentPreOrder?.paymentDate"
        [formControl]="orderForm.controls.paymentDate"
        label="Дата платежа"
        [labelOutside]="false"
      ></app-input-date>
    </div>
    <div class="w-[140px]">
      <app-input-date
        [appCompareWithField]="parentPreOrder?.expectedLoadingDate"
        [labelOutside]="false"
        [formControl]="orderForm.controls.expectedLoadingDate"
        label="Дата загрузки (оритент.)"
      ></app-input-date>
    </div>
  </div>
</div>
